import { useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { AppContext } from '../components/AppContext.tsx'
import Login from '../components/Login.jsx'

/**
 * Page wrapper to trigger the login modal and handle redirects.
 */
const LoginPage = () => {
  const { authSession, profile } = useContext(AppContext)
  const navigate = useNavigate()
  const location = useLocation()

  // If already authenticated, redirect based on onboarding status
  useEffect(() => {
    if (authSession && profile !== null) {
      if (!profile.has_completed_onboarding) {
        navigate('/onboarding', { replace: true })
      } else {
        const from = location.state?.from?.pathname || '/'
        navigate(from, { replace: true })
      }
    }
  }, [authSession, profile, navigate, location])

  return <Login />
}

export default LoginPage
